import React, {useEffect, useRef } from 'react';
import Utils from '../utils';

function ItemResult({ item, index, term, useRaw}) {
    const componentRef = useRef(null);
    
    useEffect(() => {
        // Run doCH for the current component only
        if (componentRef.current) {
          Utils.highlightSearchTerm(componentRef.current, term);
          Utils.doCH(componentRef.current);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []); // Empty dependency array ensures this runs only once after initial render

  return (
    <li className={`result-item ${item.outputLanguage2 ? `multi` : ``}`} data-id={item.id} key={index} ref={componentRef}>
        <ul className="info-container" data-id={item.id}>
            <li>
                <span>{item.id}</span>
            </li>
        </ul>
        <ul className="language-container" data-id={item.id}>
            <li>
                <strong>
                <span className={`copyable item-name class-${item.inputLanguage.color}`}>{item.inputLanguage.name}</span>
                </strong>
                {item.inputLanguage.additional_name ? (
                <span className="copyable add-name">{item.inputLanguage.additional_name}</span>
                ) : null}
                <br />
                <br />
                {useRaw ? (
                <span
                className={Utils.getDescClass(item.inputLanguage.description)}
                >{item.inputLanguage.description}</span>
                ) : (
                <span
                className={Utils.getDescClass(item.inputLanguage.description)}
                dangerouslySetInnerHTML={{
                    __html: Utils.doPreview(item.inputLanguage.description),
                }}
                ></span>
                )}
            </li>
        </ul>
        <ul className="language-container" data-id={item.id}>
            <li>
                <strong>
                <span className={`copyable item-name class-${item.outputLanguage.color}`}>{item.outputLanguage.name}</span>
                </strong>
                {item.outputLanguage.additional_name ? (
                <span className="copyable">{item.outputLanguage.additional_name}</span>
                ) : null}
                <br />
                <br />
                {useRaw ? (
                    <span
                    className={Utils.getDescClass(item.outputLanguage.description)}
                    >{item.outputLanguage.description}</span>
                ) : (
                <span
                className={Utils.getDescClass(item.outputLanguage.description)}
                dangerouslySetInnerHTML={{
                    __html: Utils.doPreview(item.outputLanguage.description),
                }}
                ></span>
                )}
            </li>
        </ul>
        {/* Check if item has outputLanguage2 */}
        {item.outputLanguage2 ? (
            <ul className="language-container" data-id={item.id}>
            <li>
                <strong>
                <span className={`copyable item-name class-${item.outputLanguage2.color}`}>{item.outputLanguage2.name}</span>
                </strong>
                {item.outputLanguage2.additional_name ? (
                <span className="copyable">{item.outputLanguage2.additional_name}</span>
                ) : null}
                <br />
                <br />
                {useRaw ? (
                    <span className={Utils.getDescClass(item.outputLanguage2.description)}>{item.outputLanguage2.description}</span>
                ) : (
                <span
                className={Utils.getDescClass(item.outputLanguage2.description)}
                dangerouslySetInnerHTML={{
                    __html: Utils.doPreview(item.outputLanguage2.description),
                }}
                ></span>
                )}
            </li>
        </ul>
        ): null}
    </li>
  );
}

export default ItemResult;